
import s from './index.module.css';
import Time from '../UI/Time';
import TimeEnd from '../UI/TimeEnd';
import Number from '../UI/Number';
import {PlusIcon} from '@/utils/icons';
import classNames from 'classnames';

const Monthly = ({regularity, changeRegularity, addRegularity, deleteRegularity, timeRange, className=''}) => {

    return (
        <div className={classNames(s.monthlyWrapper, {[className]: !!className})}>
            {
                regularity.monthly.map((el, index) => {
                    return (
                        <div key={el.id} className={s.line}>
                            <div className={s.numberWrapper}>
                                <div className={s.text}>Число</div>
                                <Number 
                                    changeRegularity={changeRegularity}
                                    index={index}
                                    number={el.number}
                                    firstField='monthly'
                                />
                            </div>
                            <div className={s.timeWrapper}>
                                <div className={s.text}>Время</div>
                                <Time 
                                    changeRegularity={changeRegularity} 
                                    index={index} 
                                    minutes={el.minutes} 
                                    hour={el.hour} 
                                    firstField='monthly'
                                />

                                {
                                    timeRange && '-'
                                }

                                {
                                    timeRange && (
                                        <TimeEnd
                                            changeRegularity={changeRegularity} 
                                            index={index} 
                                            minutesEnd={el.minutesEnd} 
                                            hourEnd={el.hourEnd} 
                                            firstField='monthly'
                                        />
                                    )
                                }

                            </div>
                            <div className={s.actionsWrapper}>
                                <div
                                    onClick={()=>{deleteRegularity(index, 'monthly')}} 
                                    className={classNames(s.actionButton, s.actionButtonRemove)}>
                                    <PlusIcon />
                                </div>
                            </div>
                            
                            
                        </div>
                    )
                })
            }
            <div className={classNames(s.actionsWrapper, 'actionsWrapper')}>
                <div className={classNames(s.actionButton, 'add')}
                        onClick={()=>{addRegularity('monthly')}}>
                    <PlusIcon />
                </div>
            </div>
            
        </div>
        
    )
}

export default Monthly;